<template>
  <el-dialog :visible.sync="visible" width="70%" :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false" :close-on-press-escape="false" @close="qx()">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '170px'">

      <h3>机构信息</h3>
      <div class="inline-box">
        <!-- <el-form-item label="金融产品所属机构" prop="publishChannels" class="styW" >
          <el-select v-model="dataForm.publishChannels" filterable clearable placeholder="请输入" class="hundred">
           <el-option 
                     v-for="item in publishChannels"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
         
        </el-form-item> -->
        <el-form-item label="产品标识" prop="productFlag" class="styW">
          <el-select v-model="dataForm.productFlag" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in flagList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="公司名称" prop="companyId" class="styW">
          <el-select v-model="dataForm.companyId" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="BD/PM" prop="bdPm" class="styW">
          <el-input v-model="dataForm.bdPm" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="产品对接类型" prop="fistLevel" class="styW">
          <el-select @change="changeType" v-model="dataForm.fistLevel" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in productFirstList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平推标识" prop="bgPush" class="styW">
          <el-select v-model="dataForm.bgPush" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in flatPushList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品对接方式" prop="productDockingMethod" class="styW">
          <el-select @change="changeMethod" v-model="dataForm.productDockingMethod" filterable clearable placeholder="请选择" class="hundred">
            <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="产品结算方式" prop="settlementMethod" class="styW">
          <el-select @change="changeSettlement" :disabled="setDisabled" v-model="dataForm.settlementMethod" filterable clearable placeholder="请选择" class="hundred">
            <el-option v-for="item in settlementList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="dataForm.settlementMethod == '1'" label="分润比例" prop="ratio" class="styW">
          <el-input v-model="dataForm.ratio" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item v-if="dataForm.productDockingMethod == '4' || dataForm.productDockingMethod == '5'" class="styW" label="协议确认" prop="returnStatus">
	      <el-select    v-model="dataForm.returnStatus" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in returnList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item v-if="dataForm.productDockingMethod == '4' || dataForm.productDockingMethod == '5'" class="styW" label="是否展示协议" prop="showProtocol">
	      <el-select  v-model="dataForm.showProtocol" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in showList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item label="是否掩码" prop="mark" class="styW">
	      <el-select v-model="dataForm.mark" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in markList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>

        <el-form-item label="APP下载模式" prop="downloadApp" class="styW">
          <el-select v-model="dataForm.downloadApp" filterable clearable placeholder="请选择">
            <el-option
                v-for="item in downloadAppList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="dataForm.productDockingMethod == '1'">
        <h3>资质筛选</h3>
        <div class="inline-box">
          <el-form-item label="芝麻分" prop="zmScore" class="styW">
            <el-select v-model="dataForm.zmScore" filterable clearable placeholder="请输入" class="hundred">
              <el-option v-for="(item,index) in zmScoreList" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <h3>产品大纲</h3>
      <div class="inline-box">
        <el-form-item label="采量来源" prop="channels" class="hundred">
          <el-button type="" @click="productionSource()">设置</el-button>
        </el-form-item>
        <el-form-item label="产品大类" prop="productCategory" class="styW">
          <el-select v-model="dataForm.productCategory" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in productCategories" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型" prop="productType" class="styW">
          <el-select v-model="dataForm.productType" filterable clearable placeholder="请输入" class="hundred">
            <el-option v-for="item in productTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="productName" class="styW">
          <el-input v-model="dataForm.productName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="产品有效期" prop="publishTime">
          <el-date-picker v-model="date1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="getTimes1" unlink-panels>
          </el-date-picker>
        </el-form-item>

        <el-form-item label="上下架时间" prop="startTime">
          <div>
            <el-select style="width: 430px;" v-model="weekday" filterable clearable multiple placeholder="请选择时间">
              <el-option v-for="item in dayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div style="margin-top: 20px;">
              <el-time-picker style="width: 430px;" is-range v-model="date" range-separator="至" start-placeholder="上架时间"
                end-placeholder="下架时间" @change="getTimes">
              </el-time-picker>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="产品有效时间" prop="productLimit" class="styW" >
       <el-date-picker
               v-model="dataForm.productLimit"
               type="date"
               placeholder="产品有效时间"
               value-format="yyyy-MM-dd HH:mm:ss">
       </el-date-picker>
      </el-form-item> -->

        <el-form-item label="产品log" prop="productLogo" class="hundred">
          <el-upload v-model="dataForm.productLogo" :action="logUrl" :on-preview="handlePictureCardPreview"
            list-type="picture-card" :on-remove="handleRemove" :limit="1" :headers="headers" :file-list="fileList"
            :on-success="successHandle">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="最高额度" prop="maximumAmount" class="styW">
          <div style="display: flex;">
            <el-input v-model="dataForm.maximumAmount" placeholder="请输入"></el-input>万
          </div>

        </el-form-item>
        <!-- <el-form-item label="还款方式" prop="repaymentType" class="styW">
          <el-input v-model="dataForm.repaymentType" placeholder="请输入"></el-input>
        </el-form-item> -->
        <el-form-item label="贷款利率" prop="productRate" class="styW">
          <el-input v-model="dataForm.productRate" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="提前还款" prop="prepayment" class="styW">
          <el-select v-model="dataForm.prepayment" filterable clearable placeholder="请输入" class="hundred">
            <el-option 
                      v-for="item in withdrawal"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item> -->
        <el-form-item label="贷款期限" prop="loanTerm" class="styW">
          <el-input v-model="dataForm.loanTerm" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="每日限额" prop="dailyLimit" class="styW">
          <el-input v-model="dataForm.dailyLimit" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="产品结算价格" prop="sellPrice" class="styW">
          <el-input :disabled="priceDisabled" v-model="dataForm.sellPrice" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="购买价格" prop="buyPrice" class="styW">
          <el-input v-model="dataForm.buyPrice" placeholder="请输入"></el-input>
      </el-form-item> -->
        <el-form-item label="排序编号" prop="sort" class="styW">
          <el-input v-model="dataForm.sort" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" class="styW">
          <el-input v-model="dataForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="准入区域" prop="productAccessArea" class="hundred">
          <el-button type="" @click="productAccessAreas()">准入区域设置</el-button>
        </el-form-item>
      </div>

      <!-- <h3>进件要求</h3>
      <el-form-item label="个人准入要求" prop="productPersonCondition"  class="hundred">
          <wealth v-model="dataForm.productPersonCondition" :valuemy="dataForm.productPersonCondition"></wealth>
      </el-form-item> 

      <el-form-item label="征信要求" prop="productCreditRequirement"  class="hundred">
        <wealth v-model="dataForm.productCreditRequirement" :valuemy="dataForm.productCreditRequirement"></wealth>
      </el-form-item> 

      <el-form-item label="企业准入要求" prop="productCompanyCondition"  class="hundred">
          <wealth v-model="dataForm.productCompanyCondition" :valuemy="dataForm.productCompanyCondition"></wealth>
      </el-form-item> 
      
      <el-form-item label="其他要求" prop="productOtherRequirement" class="hundred">
          <wealth v-model="dataForm.productOtherRequirement" :valuemy="dataForm.productOtherRequirement"></wealth>
      </el-form-item> -->

      <!-- <h3>进件资料</h3>
      <el-form-item label="进件资料" prop="productApplyInfo"  class="hundred">
          <wealth  v-model="dataForm.productApplyInfo" :valuemy="dataForm.productApplyInfo"></wealth>
      </el-form-item>  -->

      <!-- <h3>分润设置</h3>
      <el-form-item label="结算状态" prop="settlementStatus" class="styW">
          <el-select v-model="dataForm.settlementStatus" filterable clearable placeholder="请选择" class="hundred">
            <el-option 
                      v-for="item in closeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item> -->

      <!-- <div class="shareProfit">
       
          <el-row :gutter="20">
            <el-col :span="4" style="opacity: 0;"> 0</el-col>
            <el-col :span="4" style="opacity: 0;"> 0</el-col>
            <el-col :span="4">提成比例</el-col>
            <el-col :span="1" style="opacity: 0;"> 0</el-col>
            <el-col :span="4">活动奖励</el-col>
            <el-col :span="4">计提总量</el-col>
          </el-row>
      
        <br>
        <div v-for=" (item,index) in dataForm.slProductAward" :key="index">
        <el-row :gutter="24">
            <el-col :span="4">{{ getText(item.slUserVipLevelId) }}</el-col>
            <el-col :span="4">h5显示</el-col>
            <el-col :span="4">
               <el-form-item label-width="0"  :prop="`slProductAward.${index}.h5AwardRate`" :rules="[{required: true, message: $t('validate.required'), trigger: 'blur'}]"   class="hundred">
                <el-input-number size="small" v-model="dataForm.slProductAward[index].h5AwardRate" controls-position="right" @change="handleChange(item.h5AwardRate,item.accrualRate,index,1)" :precision="2" :step="0.1" :min="0" ></el-input-number>%
              </el-form-item>
            </el-col>
            <el-col :span="1">+</el-col>
            <el-col :span="4">
              <el-form-item label-width="0" :prop="`slProductAward.${index}.h5ActiveRate`" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }"  class="hundred">
              <el-input-number  size="small" v-model="dataForm.slProductAward[index].h5ActiveRate" controls-position="right" @change="handleChange(item.h5ActiveRate,item.accrualRate,index,2)" :precision="2" :step="0.1" :min="0" ></el-input-number>元/笔
            </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="0" :prop="`slProductAward.${index}.accrualRate`" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }"  class="hundred">
                <el-input-number size="small" v-model="dataForm.slProductAward[index].accrualRate" controls-position="right" @change="handleChange(item.h5ActiveRate,item.accrualRate,index,3,item.h5AwardRate)" :min="0" ></el-input-number>%
             </el-form-item>
            </el-col>
        </el-row>
        <br>
        <el-row :gutter="24">
            <el-col :span="4" style="opacity: 0;">0</el-col>
            <el-col :span="4">
              管理后台显示
            </el-col>
            <el-col :span="4"><el-input-number size="small" v-model="dataForm.slProductAward[index].backAwardRate"  :precision="2" :step="0.1"  controls-position="right" disabled></el-input-number>%</el-col>
            <el-col :span="1" >+</el-col>
            <el-col :span="4"><el-input-number size="small" v-model="dataForm.slProductAward[index].backActiveRate"  :precision="2" :step="0.1"  controls-position="right" disabled></el-input-number>元/笔</el-col>
            <el-col :span="4" style="opacity: 0;">0</el-col>
        </el-row>
      </div>
       
       
      </div> -->

      <!-- <h3>申请流程</h3>
      <el-form-item  label="申请详细流程说明链接" prop="applyStep"  class="hundred">
        
          <el-select v-model="dataForm.applyStep" multiple filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in productApplyFlow"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item> -->
      <h3>资质限制设置</h3>
      <el-form-item label="年龄范围" prop="ageScope">
        <div style="display: flex;">
          <el-input 
            style="width: 150px;" 
            v-model="ageScopeMin" 
            placeholder="请输入最小值"
            oninput="value=value.replace(/[^\d]/g,'')" 
          ></el-input>
          &nbsp;- &nbsp;
          <el-input 
            style="width: 150px;" 
            v-model="ageScopeMax" 
            placeholder="请输入最大值"
            oninput="value=value.replace(/[^\d]/g,'')" 
          ></el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item label="年龄范围" prop="ageScope" >
          <div style="display: flex;">
            <el-input style="width: 150px;" v-model="ageScopeMin" placeholder="请输入最小值"></el-input>&nbsp;- &nbsp;<el-input  style="width: 150px;" v-model="ageScopeMax" placeholder="请输入最大值"></el-input>
          </div>
      </el-form-item> -->
      <el-form-item label="资质要求" prop="qualification">
     
            <el-select  style="width: 430px;" v-model="dataForm.qualification" filterable clearable multiple placeholder="请选择资质">
              <el-option v-for="(item,index) in qualificationList" :key="`${index}-${item.label}`" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
            
        </el-form-item>

      <h3>上架配置</h3> 
      <div class="inline-box">
        <el-form-item label="是否启用" prop="status" class="styW">
          <el-select v-model="dataForm.status" filterable clearable placeholder="请选择" class="hundred">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="dataForm.id" label="状态" prop="productShow" class="styW">
          <el-input disabled v-model="dataForm.productShow" placeholder="请输入"></el-input>
        </el-form-item>
        
      </div>
        
      <div class="inline-box">
        
        <el-form-item v-if="dataForm.productDockingMethod == 1" label="H5链接" prop="productDockingMethodUrl">
          <el-input v-model="dataForm.productDockingMethodUrl" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item v-else label="上传二维码" prop="productDockingMethodUrl" >
            <el-upload
               v-model="dataForm.productDockingMethodUrl"
              :action="logUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="successHandle1"
              :headers="headers"
              :file-list="fileList1"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
       </el-form-item>  -->
      </div>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <el-dialog width="60%" title="准入区域设置" :visible.sync="innerVisible" append-to-body>
      <accessArea @allCountry="handleCountry" ref="cityRef"></accessArea>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="innerVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="gitCity()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="60%" title="屏蔽渠道采量方（可多选）" :visible.sync="channelVisible" append-to-body>
      <div>
        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
        <div class="flex-box">
          <div class="select_box" v-for="(item, index)  in channelList" :key="index">
          <el-checkbox class="select" v-model="item.isSelect" :label="item.channelName"
            @change="changeSelect(item, index)">{{ item.channelName }}</el-checkbox>
        </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="channelVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmChannel()">确 定</el-button>
      </div>
    </el-dialog>

  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import wealth from '../../../components/wealth.vue'
import accessArea from '../../../components/wx/accessArea.vue'
import cityobj from '@/utils/city'
import Cookies from 'js-cookie'
import { getList } from '../../../api/list'
export default {
  data() {
    return {
      date1: '',
      date: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 0)],
      companys: [],
      flagList: [],
      headers: { token: Cookies.get('token') },
      fileList: [],
      fileList1: [],
      vipLevels: [],
      productFirstList: [],
      logUrl: `${window.SITE_CONFIG['apiURL']}/sys/slproduct/uploadLogo`,
      dialogImageUrl: '',
      dialogVisible: false,
      visible: false,
      innerVisible: false,
      channelVisible: false,
      isIndeterminate: false,
      checkAll: false,
      priceDisabled:false,
      setDisabled:false,
      citys: [],
      cityobj: cityobj,
      productTypeList: [],
      productCategories: [],
      closeList: [],
      channelList: [],
      channel:[],
      channelListLoading: false,
      productMethodList:[],
      zmScoreList:['700分以上','650-699分','600-649分','600分以下'],
      flatPushList: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      statusList: [
        {
          label: '禁用',
          value: 0,
        },
        {
          label: '启用',
          value: 1,
        },
      ],
      showList: [
        {
          label: '否',
          value: 0,
        },
        {
          label: '是',
          value: 1,
        },
      ],
      productTypes: [],
      settlementList:[],
      productApplyFlow: [],
      publishChannels: [],
      returnList:[
      {
            'label':'进件返',
            'value':1,
        },
        {
            'label':'撞库返',
            'value':2,
        },
        {
            'label':'全流程返',
            'value':3,
        }
      ],
      markList:[
        {
            'label':'掩码',
            'value':1,
        },
        {
            'label':'非掩码',
            'value':0,
        }
      ],
      downloadAppList:[
        {
          'label':'否',
          'value':0,
        },
        {
          'label':'是',
          'value':1,
        }
      ],
      dayList: [
        { label: '星期一', value: 1 },
        { label: '星期二', value: 2 },
        { label: '星期三', value: 3 },
        { label: '星期四', value: 4 },
        { label: '星期五', value: 5 },
        { label: '星期六', value: 6 },
        { label: '星期日', value: 7 },
      ],
      weekday: [1, 2, 3, 4, 5],
      
      qualificationList:[
        { label: '车', value: 1},
        { label: '房', value: 1},
        { label: '公积金', value: 1},
        { label: '企业主', value: 1},
        { label: '社保', value: 1},
        { label: '男', value: 1},
        { label: '女', value: 1},
        { label: '无逾期', value: 1},
        { label: '满足其中一项（公积金、社保）', value: 1},
        { label: '满足其中一项（车、房）', value: 1},
        { label: '满足其中一项（车、房、公积金）', value: 1},
        { label: '满足其中一项（车、房、公积金、社保）', value: 1},
        { label: '芝麻分600分以上', value: 1},
        { label: '芝麻分650分以上', value: 1},
        { label: '芝麻分700分以上', value: 1},
      ],
      ageScopeMin:'',
      ageScopeMax:'',
      dataForm: {
        ageScope:'',
        qualification:[],
        mark: 0,
        zmScore: '',
        bgPush: '',
        fistLevel: '',
        channels: '',
        allCountry: '',
        weeklySchedule: [],
        productFlag: '',
        companyId: '',
        dailyLimit: '100000',
        sellPrice: '',
        buyPrice: '10',
        sort: '1',
        maximumAmount: '20',
        productDockingMethodUrl: '1',
        productDockingMethod: '',
        settlementMethod:'',
        ratio:'',
        slProductAward: [],
        settlementStatus: '0',
        loanTerm: '12',
        remark: '',
        prepayment: '提前还款',
        bdPm: '',
        id: '',
        productCode: '',
        productName: '',
        productLogo: '',
        productCategory: '',
        productType: '',
        creditAmount: '',
        maxRebate: '',
        productRate: '7',
        productLimit: '2099-12-30 00:00:00',
        repaymentType: '还款方式',
        productNotice: '',
        productRequiredinfo: '',
        productRebateInfo: '',
        productCompanyCondition: '1',
        productPersonCondition: '1',
        productCreditRequirement: '1',
        productOtherRequirement: '1',
        productAccessArea: '',
        productApplyInfo: '1',
        applyStep: '1',
        productOtherCondition: '',
        productSettlementMode: '',
        productIntro: '',
        productExplain: '',
        productLevel: '',
        publishChannels: '1',
        publishTime: '',
        unshelveTime: '',
        startTime: '09:00:00',
        endTime: '18:00:00',
        unshelveRemark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        channelPm: '',
        returnStatus:'',
        showProtocol:0,
      },
      withdrawal: [],
      dataRule: {
        mark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bgPush: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        fistLevel: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dailyLimit: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sellPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnStatus: [
           { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        maximumAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ratio: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 0 || value > 1) {
                callback(new Error('请输入有效值'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        settlementMethod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productDockingMethod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productDockingMethodUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // settlementStatus: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        loanTerm: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],

        // prepayment: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        bdPm: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],

        channelPm: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productLogo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productCategory: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        maxRebate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // productLimit: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // repaymentType: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        productNotice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productRequiredinfo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productRebateInfo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // productCompanyCondition: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productPersonCondition: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productCreditRequirement: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productOtherRequirement: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        productAccessArea: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channels: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // productApplyInfo: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // applyStep: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        productOtherCondition: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productSettlementMode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productIntro: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productExplain: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productLevel: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // publishChannels: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        publishTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        unshelveTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        unshelveRemark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },

  components: {
    wealth,
    accessArea,
  },
  methods: {
    init() {
      this.visible = true
      this.fileList = []
      this.fileList1 = []
      this.getCompanysOptions()
      this.getDeliveryChannel()
      this.getCityOptions()
      this.getProductTypeOptions()
      this.getproductTypesFirst()
      this.getproductCategoriesOptions()
      this.getcloseListCategoriesOptions()
      this.getproductTypesOptions()
      this.getsettlementMethodOptions()
      this.getapplyStepOptions()
      this.gitShareProfit()
      this.getProductFlag()
      this.getvipLevelOptions()
      this.getpublishChannelsOptions()
      this.getwithdrawalOptions()
      this.cityobj.provinces.forEach(item => {
        item.istrue = false
        item.isIndeterminate = false
        item.cities.forEach(item1 => {
          item1.istrue = false
        })
      })

    },
    handleCountry(val) {
      this.dataForm.allCountry = val
      // console.log(1273, val);

    },
    changeSettlement(){
      if(this.dataForm.settlementMethod == '1' || this.dataForm.settlementMethod == '2'){
        this.priceDisabled = true
        this.dataForm.sellPrice = '0'
      }else{
        this.priceDisabled = false
      }
      if(this.dataForm.settlementMethod != '1'){
        this.dataForm.ratio = ''
      }
    },
    changeMethod(){
      if(this.dataForm.productDockingMethod == '4' || this.dataForm.productDockingMethod == '5'){
        this.setDisabled = false
        this.priceDisabled = false
      }else if(this.dataForm.productDockingMethod == '1' || this.dataForm.productDockingMethod == '2'){
          this.dataForm.settlementMethod = '0'
          // this.dataForm.sellPrice = '0'
          // this.priceDisabled = true
          this.setDisabled = true
          this.dataForm.returnStatus = ''
      }else{
        this.setDisabled = true
        this.priceDisabled = false
        this.dataForm.settlementMethod = '0'
        this.dataForm.returnStatus = ''
      }
    },
    changeType(){
      this.dataForm.productDockingMethod = null
      this.dataForm.settlementMethod = null
      this.priceDisabled = false
      this.setDisabled = false
      // console.log(2345,this.dataForm.fistLevel);
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.productTypes = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productTypes.push({ label: element.dictLabel, value: element.dictValue })
            if(this.dataForm.fistLevel == '0'){
              let labelsToKeep = ["5","7"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
        
            }else if(this.dataForm.fistLevel == '1'){
              let labelsToKeep = ["0","4"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
            }else if(this.dataForm.fistLevel == '2'){
              let labelsToKeep = ["1","2"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
            }else{
              this.productTypes = []
            }
          })
        }
      }).catch(() => { })
      
      
    },
    //一级change事件
    handleCheckAllChange(val) {
      // console.log('一级change事件', val)
      this.channelList.forEach(item => {
        item.isSelect = val

      })
      this.dataForm.channels = JSON.stringify(this.channelList)

      this.isIndeterminate = false;
    },
    changeSelect(element, index) {
      // console.log('changeSelect', element);

      this.isIndeterminate = false
      this.channelList[index].isSelect = element.isSelect
      this.dataForm.channels = JSON.stringify(this.channelList)
      if (this.channelList.every(item => item.isSelect)) {
        this.checkAll = true
      } else if (this.channelList.every(item => !item.isSelect)) {
        this.checkAll = false
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    confirmChannel() {
      this.channelVisible = false
      
    },
    getTimes() {
      if (this.date != null) {
        // console.log(333, this.date);

        this.dataForm.startTime = this.date[0]
        this.dataForm.endTime = this.date[1]
      } else {
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
      }
    },
    getTimes1() {
      if (this.date1 != null) {
        this.dataForm.publishTime = this.date1[0]
        this.dataForm.unshelveTime = this.date1[1]
      } else {
        this.dataForm.publishTime = ''
        this.dataForm.unshelveTime = ''
      }

    },
    // 初始化投放渠道
    async getDeliveryChannel() {
      this.channelListLoading = true
      return this.$http.get(`/sys/channels/page`, {
        params: {
          page: 1,
          limit: 100000
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          this.channelListLoading = false
          return this.$message.error(res.msg)
        }
        this.channelList = []
        this.channel = res.data.list
        res.data.list.forEach(item => {
          this.channelList.push({ id: item.id, channelName: item.name, isSelect: false })
        })
        this.channelListLoading = false
        if (this.dataForm.id) {
          this.getInfo()
        }
      }).catch(() => {
        this.channelListLoading = false
      })
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id, standard: element.standard });
            });
          }
        })
        .catch(() => { });
    },
    handleChange(n1, n2, index, type, n3) {
      if (type == 1) {
        this.dataForm.slProductAward[index].backAwardRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
        return
      }
      if (type == 2) {
        this.dataForm.slProductAward[index].backActiveRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
        return
      }

      this.dataForm.slProductAward[index].backAwardRate = (n3 + n3 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
      this.dataForm.slProductAward[index].backActiveRate = (n1 + n1 * ((n2 / 100).toFixed(2) - 0)).toFixed(2)
    },
    // 图片
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    successHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.productLogo = res.data
    },
    successHandle1(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.productDockingMethodUrl = res.data
    },
    productAccessAreas() {
      this.innerVisible = true
      this.$nextTick(() => {

        if (this.dataForm.id) {
          this.$refs.cityRef.init(JSON.parse(this.dataForm.productAccessArea))
        } else {
          this.$refs.cityRef.init(this.cityobj)
        }
      })

    },
    productionSource() {
      if (this.channelListLoading) {
        return this.$message.warning('渠道列表加载中，请稍后重试')
      }
      this.channelVisible = true
    //  console.log(34,this.channelList);

      this.$nextTick(() => {
        if (this.channelList.every(item => item.isSelect)) {
          this.checkAll = true
        }
      })
      // this.$nextTick(() => {
      // console.log(34,this.channelList);

      // this.dataForm.channels = JSON.parse(this.channelList)
      // })
    },
    getText(txt) {
      return this.vipLevels.filter(item => item.value == txt)[0]?.label
    },
    async gitShareProfit() {
      let res = await this.$http.get(`/sys/slproductaward/award`)

      res.data.data.forEach(item => {
        item.accrualRate = 0
        item.backActiveRate = 0
        item.backAwardRate = 0
        item.h5ActiveRate = 0
        item.h5AwardRate = 0
        item.slUserVipLevelId = 1
      })
      this.dataForm.slProductAward = res.data.data
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
       
      })

    },

    gitCity() {
      this.dataForm.productAccessArea = JSON.stringify(this.$refs.cityRef.cityobj)
      this.innerVisible = false
      // console.log(this.dataForm.productAccessArea)
    },
    // /sys/mechanism/list
    async getpublishChannelsOptions() {
      // affiliatedInstitutions
      getList('/sys/dict/data/list?dataType=affiliatedInstitutions').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // console.log(res)
        this.publishChannels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.publishChannels.push({ label: element.dictLabel, value: element.dictLabel })
          })
        }
      }).catch(() => { })

    },
    async getProductFlag() {
      getList('/sys/dict/data/list?dataType=productFlag').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // console.log(res)
        this.flagList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.flagList.push({ label: element.dictLabel, value: element.dictLabel })
          })
        }
      }).catch(() => { })

    },

    async getwithdrawalOptions() {
      // affiliatedInstitutions
      getList('/sys/dict/data/list?dataType=prepayment').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // console.log(res)
        this.withdrawal = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.withdrawal.push({ label: element.dictLabel, value: element.dictLabel })
          })
        }
      }).catch(() => { })

    },
    async getvipLevelOptions() {
      getList(`/sys/sluserviplevel/page`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.vipLevels = [];
        if (res.data != null) {
          res.data.list.forEach(element => {
            this.vipLevels.push({ label: element.name, value: element.logo })
          })
        }
      }).catch(() => { })
    },
    //初始化下拉框中的选项
    async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.citys.push({ label: element.dictLabel, value: element.dictValue })
          })
          /*let citys = {}
          for(let i = 0; i< res.data.length; i++){
              citys[i].value=res.data[i].dictValue
              citys[i].label=res.data[i].dictLabel
          }*/
        }
      }).catch(() => { })
    },

    async getproductCategoriesOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=product_categories`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.productCategories = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productCategories.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    // 上架配置
    // async getputawayOptions() {
    //     this.$http.get(`/sys/dict/data/list?dataType=putaway`).then(({ data: res }) => {
    //         if (res.code !== 0) {
    //             return this.$message.error(res.msg)
    //         }
    //          this.statusList = [];
    //         if (res.data!=null){
    //             res.data.forEach(element => {
    //              this.statusList.push({label: element.dictLabel ,value: element.dictValue})
    //             })
    //         }
    //     }).catch(() => {})
    // },
    // 产品对接方式
    async getproductTypesOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.productMethodList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productMethodList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    // 产品结算方式
    async getsettlementMethodOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=settlementMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.settlementList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.settlementList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    // 产品对接类型
    async getproductTypesFirst() {
      this.$http.get(`/sys/dict/data/list?dataType=product_first_type`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.productFirstList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productFirstList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    async getcloseListCategoriesOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=closeType`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.closeList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.closeList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    async getProductTypeOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=product_type`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.productTypeList = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productTypeList.push({ label: element.dictLabel, value: element.dictValue })
          })
        }
      }).catch(() => { })
    },
    // 申请流程
    async getapplyStepOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=productApplyFlow`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.productApplyFlow = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.productApplyFlow.push({ label: element.dictLabel, value: element.dictLabel })
          })
        }
      }).catch(() => { })
    },
    // 获取信息
    getInfo() {
      this.$http.get(`/sys/slproduct/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        let arr = []
        for (const key in res.data.applyStep) {
          arr.push(res.data.applyStep[key])
        }

        this.fileList.push({ url: res.data.productLogo })
        this.fileList1.push({ url: res.data.productDockingMethodUrl })

        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          // applyStep: arr,
        }
        if(this.dataForm.qualification != null){
          this.dataForm.qualification = JSON.parse(this.dataForm.qualification)
           this.dataForm.qualification =  this.dataForm.qualification.map(item => item.label)
          
        }
       
        
        if(this.dataForm.returnStatus == 0){
          this.dataForm.returnStatus = null
        }
        if(this.dataForm.productDockingMethod == '4' || this.dataForm.productDockingMethod == '5'){
          this.setDisabled = false
          this.priceDisabled = false
        }else if(this.dataForm.productDockingMethod == '1' || this.dataForm.productDockingMethod == '2'){
          this.dataForm.settlementMethod = '0'
          // this.dataForm.sellPrice = '0'
          // this.priceDisabled = true
          this.setDisabled = true
          this.dataForm.returnStatus = ''
        }else{
          this.setDisabled = true
          this.priceDisabled = false
          this.dataForm.settlementMethod = '0'
          this.dataForm.returnStatus = ''
        }
        if(this.dataForm.settlementMethod == '1' || this.dataForm.settlementMethod == '2'){
          this.priceDisabled = true
          this.dataForm.sellPrice = '0'
        }else{
          this.priceDisabled = false
        }
        this.productMethodList.forEach(element => {
            this.productTypes.push({ label: element.label, value: element.value })
            if(this.dataForm.fistLevel == '0'){
              let labelsToKeep = ["5","7"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
        
            }else if(this.dataForm.fistLevel == '1'){
              let labelsToKeep = ["0","4"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
            }else if(this.dataForm.fistLevel == '2'){
              let labelsToKeep = ["1","2"];
              this.productTypes = this.productTypes.filter(item => labelsToKeep.includes(item.value));
            }else{
              this.productTypes = []
            }
          })
        if (res.data.channels != "null" && res.data.channels != null && res.data.channels != "") {
          this.channelList = JSON.parse(res.data.channels)
          this.channel.forEach(item2 => {
            if (!this.channelList.some(item1 => item1.id === item2.id)) {
              this.channelList.push({id: item2.id, channelName: item2.name, isSelect: false});
            }
          });
        }
        
         if(this.dataForm.ageScope != null){
          const [part1, part2] = this.dataForm.ageScope.split("-");
          this.ageScopeMin = part1
          this.ageScopeMax = part2
        }



        this.dataForm.productShow = res.data.productShow == '1' ? '上架' : '下架'
        this.date1 = [this.dataForm.publishTime, this.dataForm.unshelveTime]
        if (res.data.weeklySchedule) {
          let weeklySchedule = JSON.parse(res.data.weeklySchedule)
          this.weekday = []
          weeklySchedule.forEach(item => {
            this.weekday.push(item.dayOfWeek)
          })
          this.dataForm.startTime = weeklySchedule[0].startTime
          this.dataForm.endTime = weeklySchedule[0].endTime
          const [startHour, startMinute, startSecond] = this.dataForm.startTime.split(':');
          const [endHour, endMinute, endSecond] = this.dataForm.endTime.split(':');
          this.date = [new Date(2024, 9, 10, startHour, startMinute, startSecond), new Date(2024, 9, 10, endHour, endMinute, endSecond)]
        }




      }).catch(() => { })
     
    },
    qx() {
      this.date1 = [],
        this.date = [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 0)]
      this.visible = false
      this.productTypes = []
      this.dataForm.returnStatus = ''
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {

      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.qualification = JSON.stringify(
          (this.dataForm.qualification || []).map(item => ({ label: item, value: 1 }))
        );
        if (this.ageScopeMin !== '' && this.ageScopeMin != null && this.ageScopeMax !== '' && this.ageScopeMax != null) {
          this.dataForm.ageScope = `${this.ageScopeMin}-${this.ageScopeMax}`;
        } else {
          // 如果都没填，根据业务需求设为空字符串或 null
          this.dataForm.ageScope = ''; 
        }  
        const shortFormatRegex = /^\d{2}:\d{2}:\d{2}$/;
        if (shortFormatRegex.test(this.dataForm.startTime)) {
          let startTime = this.dataForm.startTime
          let endTime = this.dataForm.endTime
          let weeklySchedule = []
          this.weekday.forEach(item => {
            weeklySchedule.push({
              dayOfWeek: item,
              startTime: startTime,
              endTime: endTime
            })
          })
          this.dataForm.weeklySchedule = JSON.stringify(weeklySchedule)
        } else {
          let myStart = this.dataForm.startTime
          const startHours = myStart.getHours();
          const startMinutes = myStart.getMinutes();
          const startSeconds = myStart.getSeconds();
          let startTime = `${startHours.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}:${startSeconds.toString().padStart(2, '0')}`

          let myEnd = this.dataForm.endTime
          const endHours = myEnd.getHours();
          const endMinutes = myEnd.getMinutes();
          const endSeconds = myEnd.getSeconds();
          let endTime = `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}:${endSeconds.toString().padStart(2, '0')}`
          let weeklySchedule = []
          this.weekday.forEach(item => {
            weeklySchedule.push({
              dayOfWeek: item,
              startTime: startTime,
              endTime: endTime
            })
          })
          this.dataForm.weeklySchedule = JSON.stringify(weeklySchedule)
        }

        this.dataForm.productShow = null
        delete this.dataForm.startTime
        delete this.dataForm.endTime
        
        if(!this.channelList.some(channel => channel.isSelect)){
          this.dataForm.channels = ""
        }
        if(!this.dataForm.returnStatus){
          this.dataForm.returnStatus = 0
        }
        this.dataForm.productDockingMethodUrl = this.dataForm.productDockingMethodUrl.trim()
        let obj = {}
        // this.dataForm.applyStep.forEach((item,index) => {
        //   obj[index+1] = item
        // })


        // applyStep: { dto: obj}
        // this.dataForm.productPersonCondition = JSON.stringify(this.dataForm.productPersonCondition)
        // this.dataForm.productCreditRequirement = JSON.stringify(this.dataForm.productCreditRequirement)
        // this.dataForm.productCompanyCondition = JSON.stringify(this.dataForm.productCompanyCondition)
        // this.dataForm.productotherRequirement = JSON.stringify(this.dataForm.productotherRequirement)
        // this.dataForm.productApplyInfo = JSON.stringify(this.dataForm.productApplyInfo)
        // this.dataForm.productOtherRequirement = JSON.stringify(this.dataForm.productOtherRequirement)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slproduct/', { ...this.dataForm, applyStep: { "1": "进件申请" }, }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm.startTime = '09:00:00'
          this.dataForm.endTime = '18:00:00'
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => { })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.inline-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.el-form-item {
  margin-right: 40px;
}

.styW {
  width: 400px;
}

::v-deep .el-date-editor--date {
  width: 100%;
}

h3 {
  margin: 30px 0;
}

.shareProfit {
  margin-left: 30px;
}

::v-deep .el-col {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

::v-deep .el-input-number {
  width: 100px;
}

.select_box {
  margin-left: 18px;
  width: 200px;
  

  .select {
    line-height: 25px;
  }
}
.flex-box{
  display: flex;
  flex-wrap: wrap;
}
</style>
